export default {
  lang: "jp",
  fontFamily: "jp-font-family",
  fontFamilyTitle: "jp-font-family-title",
  requestLang: "ja_JP",
  type: "en",
};
